import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import queryString from 'query-string';
import { retrievePnr } from '../redux/actions';
import Pictogram from '../scripts/components/global/pictogram';
import TranslatedCopy from '../scripts/intl/translated-copy';
import Header from '../scripts/components/global/header';
import Footer from '../scripts/components/global/footer';
import IropsManageBookedInformation from '../scripts/components/irops-acceptance/irops-manage-booked-information';
import IropsSegmentData from '../scripts/components/irops-acceptance/irops-segmentdata';
import { changeItineraryAction } from '../redux/actions';
import { retrieveAllDestinationInfo } from '../redux/actions';
import { redirectExchanges } from '../scripts/utilities/helpers';
import { sendAnalytics } from '../scripts/analytics/tracker';
import manageTracking from '../scripts/analytics/creators/manage';


const mapStateToProps = state => {
  return ({
    allDestinationInfo: state.Manage.allDestinationInfo,
    country: state.LanguageBundle.country,
    language: state.Manage.language,
    pnrInfo: state.Manage.pnrInfo,
    priorityList: state.PriorityList.priorityList,
    stateStoreFront: state.Manage.stateStoreFront,
  });
};

function IropsatcView(props) {
  const {
    allDestinationInfo,
    country,
    dispatch,
    language,
    pnrInfo,
    priorityList,
    stateStoreFront,
  } = props;

  useEffect(() => {
    const urlParams = queryString.parse(props?.location?.search);
    if (Object?.keys(urlParams)?.length > 0) {
      const getPNR = urlParams?.pnr;
      const getLastName = urlParams['last-name'];
      if (getPNR !== '' && getPNR !== null && getLastName !== '' && getLastName !== null) {
        const params = {
          pnr: getPNR,
          lastName: getLastName,
        };
        dispatch(retrievePnr(country, language, params));
        if (pnrInfo?.pnrCode) {
          dispatch(retrieveAllDestinationInfo(language, pnrInfo.getAllDestinationsCode()));
          setTimeout(() => {
            setLoaderIcon(false);
            setItinearyCards(true);
          }, 9000);
        } else {
          setTimeout(() => {
            setLoaderIcon(false);
          }, 50000);
        }
      } else {
        setLoaderIcon(false);
      }
    }
  }, [pnrInfo.pnrCode]);

  const [loaderIcon, setLoaderIcon] = useState(true);
  const [itinearyCards, setItinearyCards] = useState(false);
  const [tripAcceptance, setTripAcceptance] = useState(false);

  let flightTime = '';
  let segmentCollection = '';
  let legsCollection = '';
  let segmentData = '';
  const tripType = pnrInfo?.flightItineraryType;
  const legs = pnrInfo?.legCollection;
  const oldLegs = pnrInfo?.legsOrigin?._legCollection;

  const tripClasses = cx({
    'not-accepted': !tripAcceptance,
    'accepted': tripAcceptance,
  });

  const handleTripChanges = () => {
    setLoaderIcon(true);    
    setItinearyCards(false);
    const cartID = pnrInfo?.cart?.cartId;
    const passengers = pnrInfo?.getAllPassengers();
    const lastNameValue = passengers?.[0]?.lastName;
    const listFlightInfo = pnrInfo?.getListFlightInfo();
    const pageRedirect = true;    
    const pnrValue = pnrInfo?.pnrCode;
    const post = 'web';
    const store = stateStoreFront?.code;
    dispatch(changeItineraryAction(pnrValue, lastNameValue, post, store, cartID, listFlightInfo, pageRedirect, country, language));
    setTripAcceptance(true);
    flightTime = 'protection-flight';
    setTimeout(() => {
      setLoaderIcon(false);      
      setItinearyCards(true);
    }, 5000);

    dispatch(sendAnalytics({ eventCreator: manageTracking.trackAutoAccept(pnrInfo) }));
  };
  
  const flightSegmentType = [];
  if (tripAcceptance === false) {
    legsCollection = legs?.map((segments) => {
      segmentCollection = segments?.segmentsCollection;
      segmentData = segmentCollection?.map(values => {
        if (values?.segmentStatus === 'SC' && (!values?.isChangeOds || !values?.isChangeOag || !values?.isCancelOds || !values?.isCancelOag)) {
          flightSegmentType.push('flight-delayed');
          values.flightSegmentType = 'flight-delayed';
        } else if ((values?.segmentStatus === 'WK' || values?.segmentStatus === 'SC') && (values?.isCancelOag || values?.isCancelOds)) {
          flightTime = 'flight-cancel';
          flightSegmentType.push('flight-cancel');
          values.flightSegmentType = 'flight-cancel';
        } else {
          flightTime = 'flight-onTime';
          flightSegmentType.push('flight-onTime');
          values.flightSegmentType = 'flight-onTime';
        }

        if (segments?.itineraryPartType === 'OUTBOUND') {
          values.segmentItineraryType = 'OUTBOUND';
        } else {
          values.segmentItineraryType = 'INBOUND';
        }
      });
    });
  }
  const flightSegment = [...new Set(flightSegmentType)];
  const checkOperationalWindow = legs?.flatMap((leg) => leg?.segmentsCollection?.map((segment) => {
    const { isCancelOag, isCancelOds, isChangeOag, isChangeOds, segmentStatus } = segment;
    return (isCancelOag || isCancelOds || isChangeOag || isChangeOds) && (segmentStatus === 'WK' || segmentStatus === 'SC');
  }));

  const checkOperationalWindowValue = checkOperationalWindow?.includes(true);
  const operationalWindowStatus = checkOperationalWindowValue && flightSegmentType.includes('flight-cancel') ? true : false;
  const passengers = pnrInfo?.getAllPassengers();
  const pnrValue = pnrInfo?.pnrCode;
  const customerName = passengers?.[0]?.lastName;
  const linkButtonExchanges =  stateStoreFront?.linkBetaCC || '';
  const isPriorityList = priorityList?.data?.isPriorityList || false;
  const hasCheckin = priorityList?.data?.checkin || false;
  const params = `ckn=${hasCheckin}&pl=${isPriorityList}&utm_source=myb20&utm_medium=itinerary-button`;

  useEffect(() => {
    if ( pnrInfo.pnrCode !== undefined ) {
      dispatch(retrieveAllDestinationInfo(language, pnrInfo.getAllDestinationsCode()));
    }
  }, [pnrInfo.pnrCode]); 

  if ( pnrInfo.pnrCode !== undefined ) {
    dispatch(retrieveAllDestinationInfo(language, pnrInfo.getAllDestinationsCode()));
  }
  
  return (
    <div className='iropsatc-main-container Content'>
      <div className='header-container'>
        <Header
          country={ country }
          hideMenuList={ true } 
          language={ language }
        />
      </div>
      <div className='iropsatc-section'>
        <div className='manage-booking'>
          <div className='booking-frame'>
            <div className='manage-content-section'>
              <div className='check-flight-status-session'>
                <div className='flight-ticket-icon'>
                  <Pictogram
                    className='flight-TicketIcon'
                    id='TicketIcon'
                  />
                </div>
                <div className='check-flight-status'>
                  <TranslatedCopy
                    className='status-message-1'
                    copyID='MYB_CHECK_THE_STATUS'
                    tagName='p'
                  />
                  <TranslatedCopy
                    className='status-message-2'
                    copyID='MYB_USER_RESERVATION'
                    tagName='p'
                  />
                </div>
              </div>
              { !itinearyCards || !tripType ?
                <IropsManageBookedInformation loaderIcon={ loaderIcon } /> :
                <>
                  { <>
                    <div className='irops-itinerary-cards-container'>
                      <section className='itinerary-section'>
                        {
                          <IropsSegmentData
                            allDestinationInfo={ allDestinationInfo }
                            country={ country }
                            dispatch={ dispatch }
                            flightSegmentType = { flightSegment }
                            flightTime={ flightTime }
                            language={ language }
                            legs={ legs }
                            legsCollection={ legsCollection }
                            oldLegs={ oldLegs }
                            operationalWindowStatus={ operationalWindowStatus }
                            pnrInfo={ pnrInfo }
                            priorityList={ priorityList }
                            segmentData={ segmentData }
                            stateStoreFront={ stateStoreFront }
                            tripType={ tripType }
                          />
                        }
                      </section>
                    </div>
                  </> }
                </> }
            </div>
          </div>
        </div>
      </div>
      <div className='footer-container'>
        <div className='acceptance-but-section'>
          { itinearyCards && flightSegmentType.includes('flight-delayed') || itinearyCards && operationalWindowStatus || tripAcceptance ?
            <div className='success-message-section'>
              <div className='irops-book-button-container'>
                <div className='irops-button-container'>
                  <div className={ `submit-button ${tripClasses}` } onClick={ operationalWindowStatus ? () => redirectExchanges(linkButtonExchanges, customerName, pnrValue, params) : handleTripChanges } >
                    <TranslatedCopy
                      className='irops-book-button'
                      copyID={ operationalWindowStatus ? 'MYB_CHOOSE_ANOTHER_FLIGHT' : 'MYB_ACCEPT_PROTECTIVE_FLIGHT' }
                      tagName='button'
                    />
                  </div>
                </div>
              </div>
            </div> : null }

        </div>
        <Footer
          country={ country }
          hideMenuList={ true }
          language={ language }
        />
      </div>
    </div>
  );
}

IropsatcView = connect(mapStateToProps)(IropsatcView);
export default IropsatcView;